module.exports = __webpack_public_path__ + "media/images/tavour_logo_small-0e93ecab84c2706b04fe873b1b378dff.png";